"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivitiesApi = exports.ActivitiesApiFactory = exports.ActivitiesApiFp = exports.ActivitiesApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * ActivitiesApi - axios parameter creator
 */
const ActivitiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Copies activities to a new recipient.
         * @summary Copy activities to a new recipient
         * @param {number} recipientId ID of the recipient self circle
         * @param {ActivitiesCopyRecipientRequest} [activitiesCopyRecipientRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesCopyActivitiesV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, activitiesCopyRecipientRequest, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('activitiesCopyActivitiesV1', 'recipientId', recipientId);
            const localVarPath = `/v1/activities/recipients/{recipient_id}/copy`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authz_circle_jwt required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/activities/recipients/{recipient_id}/copy`,
                sdkMethod: 'activitiesCopyActivitiesV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(activitiesCopyRecipientRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Builds or returns the daily activities list for the recipient. The decision whether to build a new list or return the existing is based on the required `tz` query parameter - if daily activities have not yet been generated for the user\'s current day (determined by timezone), then a new daily activities list is generated and returned. Otherwise, the list which has already been generated is returned.  Pinned activities are also included in the list and will appear at the front of the list, indicated by `pinnedAt` being non-null.
         * @summary Build or retrieve daily activities list
         * @param {number} recipientId ID of the recipient self circle
         * @param {string} tz IANA timezone identifier (e.g., America/Los_Angeles, Europe/London)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesGetActivitiesListV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, tz }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('activitiesGetActivitiesListV1', 'recipientId', recipientId);
            // verify required parameter 'tz' is not null or undefined
            (0, common_1.assertParamExists)('activitiesGetActivitiesListV1', 'tz', tz);
            const localVarPath = `/v1/activities/recipients/{recipient_id}/activities`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authz_circle_jwt required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/activities/recipients/{recipient_id}/activities`,
                sdkMethod: 'activitiesGetActivitiesListV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the details for a single user activity based on its ID.
         * @summary get activity details
         * @param {number} recipientId ID of the recipient self circle
         * @param {number} activityId ID of the user activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesGetActivityDetailsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, activityId }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('activitiesGetActivityDetailsV1', 'recipientId', recipientId);
            // verify required parameter 'activityId' is not null or undefined
            (0, common_1.assertParamExists)('activitiesGetActivityDetailsV1', 'activityId', activityId);
            const localVarPath = `/v1/activities/recipients/{recipient_id}/activities/{activity_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{activity_id}', encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authz_circle_jwt required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/activities/recipients/{recipient_id}/activities/{activity_id}`,
                sdkMethod: 'activitiesGetActivityDetailsV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update an existing activity for a specific recipient.  This endpoint allows callers to update the pinned or completion status of an activity by ID for a given recipient.   Limitations:  - Only `self_attest` activities can be marked as completed through this route. - Only one operation of either `pinned` or `completed` can be performed per request.
         * @summary Update an activity
         * @param {number} recipientId ID of the recipient self circle
         * @param {number} activityId ID of the user activity
         * @param {ActivitiesPatchActivityRequest} [activitiesPatchActivityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesPatchActivityV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, activityId, activitiesPatchActivityRequest, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('activitiesPatchActivityV1', 'recipientId', recipientId);
            // verify required parameter 'activityId' is not null or undefined
            (0, common_1.assertParamExists)('activitiesPatchActivityV1', 'activityId', activityId);
            const localVarPath = `/v1/activities/recipients/{recipient_id}/activities/{activity_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{activity_id}', encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authz_circle_jwt required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/activities/recipients/{recipient_id}/activities/{activity_id}`,
                sdkMethod: 'activitiesPatchActivityV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(activitiesPatchActivityRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Generic endpoint for handling Google Cloud Pub/Sub push subscription messages. Currently supports CheckinCreatedEvent for activity regeneration based on checkin completion.  This endpoint receives push messages from Google Cloud Pub/Sub and processes them asynchronously. The endpoint validates the Pub/Sub message format and routes events to appropriate handlers based on event type.
         * @summary Pub/Sub message receiving endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesPubsubV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({}, options = {}) {
            const localVarPath = `/v1/activities/pubsub`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication GoogleBearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/activities/pubsub`,
                sdkMethod: 'activitiesPubsubV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces an activity with a relevant replacement.
         * @summary replace activity
         * @param {number} recipientId ID of the recipient self circle
         * @param {number} activityId ID of the user activity
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesReplaceUserActivityV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, activityId, body, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('activitiesReplaceUserActivityV1', 'recipientId', recipientId);
            // verify required parameter 'activityId' is not null or undefined
            (0, common_1.assertParamExists)('activitiesReplaceUserActivityV1', 'activityId', activityId);
            const localVarPath = `/v1/activities/recipients/{recipient_id}/activities/{activity_id}/replace`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{activity_id}', encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authz_circle_jwt required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/activities/recipients/{recipient_id}/activities/{activity_id}/replace`,
                sdkMethod: 'activitiesReplaceUserActivityV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ActivitiesApiAxiosParamCreator = ActivitiesApiAxiosParamCreator;
/**
 * ActivitiesApi - functional programming interface
 */
const ActivitiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ActivitiesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Copies activities to a new recipient.
         * @summary Copy activities to a new recipient
         * @param {number} recipientId ID of the recipient self circle
         * @param {ActivitiesCopyRecipientRequest} [activitiesCopyRecipientRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesCopyActivitiesV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activitiesCopyActivitiesV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ActivitiesApi.activitiesCopyActivitiesV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Builds or returns the daily activities list for the recipient. The decision whether to build a new list or return the existing is based on the required `tz` query parameter - if daily activities have not yet been generated for the user\'s current day (determined by timezone), then a new daily activities list is generated and returned. Otherwise, the list which has already been generated is returned.  Pinned activities are also included in the list and will appear at the front of the list, indicated by `pinnedAt` being non-null.
         * @summary Build or retrieve daily activities list
         * @param {number} recipientId ID of the recipient self circle
         * @param {string} tz IANA timezone identifier (e.g., America/Los_Angeles, Europe/London)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesGetActivitiesListV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activitiesGetActivitiesListV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ActivitiesApi.activitiesGetActivitiesListV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns the details for a single user activity based on its ID.
         * @summary get activity details
         * @param {number} recipientId ID of the recipient self circle
         * @param {number} activityId ID of the user activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesGetActivityDetailsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activitiesGetActivityDetailsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ActivitiesApi.activitiesGetActivityDetailsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update an existing activity for a specific recipient.  This endpoint allows callers to update the pinned or completion status of an activity by ID for a given recipient.   Limitations:  - Only `self_attest` activities can be marked as completed through this route. - Only one operation of either `pinned` or `completed` can be performed per request.
         * @summary Update an activity
         * @param {number} recipientId ID of the recipient self circle
         * @param {number} activityId ID of the user activity
         * @param {ActivitiesPatchActivityRequest} [activitiesPatchActivityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesPatchActivityV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activitiesPatchActivityV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ActivitiesApi.activitiesPatchActivityV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Generic endpoint for handling Google Cloud Pub/Sub push subscription messages. Currently supports CheckinCreatedEvent for activity regeneration based on checkin completion.  This endpoint receives push messages from Google Cloud Pub/Sub and processes them asynchronously. The endpoint validates the Pub/Sub message format and routes events to appropriate handlers based on event type.
         * @summary Pub/Sub message receiving endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesPubsubV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activitiesPubsubV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ActivitiesApi.activitiesPubsubV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces an activity with a relevant replacement.
         * @summary replace activity
         * @param {number} recipientId ID of the recipient self circle
         * @param {number} activityId ID of the user activity
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesReplaceUserActivityV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activitiesReplaceUserActivityV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ActivitiesApi.activitiesReplaceUserActivityV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.ActivitiesApiFp = ActivitiesApiFp;
/**
 * ActivitiesApi - factory interface
 */
const ActivitiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ActivitiesApiFp)(configuration);
    return {
        /**
         * Copies activities to a new recipient.
         * @summary Copy activities to a new recipient
         * @param {number} recipientId ID of the recipient self circle
         * @param {ActivitiesCopyRecipientRequest} [activitiesCopyRecipientRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesCopyActivitiesV1(params, options) {
            return localVarFp
                .activitiesCopyActivitiesV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Builds or returns the daily activities list for the recipient. The decision whether to build a new list or return the existing is based on the required `tz` query parameter - if daily activities have not yet been generated for the user\'s current day (determined by timezone), then a new daily activities list is generated and returned. Otherwise, the list which has already been generated is returned.  Pinned activities are also included in the list and will appear at the front of the list, indicated by `pinnedAt` being non-null.
         * @summary Build or retrieve daily activities list
         * @param {number} recipientId ID of the recipient self circle
         * @param {string} tz IANA timezone identifier (e.g., America/Los_Angeles, Europe/London)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesGetActivitiesListV1(params, options) {
            return localVarFp
                .activitiesGetActivitiesListV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns the details for a single user activity based on its ID.
         * @summary get activity details
         * @param {number} recipientId ID of the recipient self circle
         * @param {number} activityId ID of the user activity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesGetActivityDetailsV1(params, options) {
            return localVarFp
                .activitiesGetActivityDetailsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an existing activity for a specific recipient.  This endpoint allows callers to update the pinned or completion status of an activity by ID for a given recipient.   Limitations:  - Only `self_attest` activities can be marked as completed through this route. - Only one operation of either `pinned` or `completed` can be performed per request.
         * @summary Update an activity
         * @param {number} recipientId ID of the recipient self circle
         * @param {number} activityId ID of the user activity
         * @param {ActivitiesPatchActivityRequest} [activitiesPatchActivityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesPatchActivityV1(params, options) {
            return localVarFp
                .activitiesPatchActivityV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Generic endpoint for handling Google Cloud Pub/Sub push subscription messages. Currently supports CheckinCreatedEvent for activity regeneration based on checkin completion.  This endpoint receives push messages from Google Cloud Pub/Sub and processes them asynchronously. The endpoint validates the Pub/Sub message format and routes events to appropriate handlers based on event type.
         * @summary Pub/Sub message receiving endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesPubsubV1(params, options) {
            return localVarFp
                .activitiesPubsubV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Replaces an activity with a relevant replacement.
         * @summary replace activity
         * @param {number} recipientId ID of the recipient self circle
         * @param {number} activityId ID of the user activity
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitiesReplaceUserActivityV1(params, options) {
            return localVarFp
                .activitiesReplaceUserActivityV1(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.ActivitiesApiFactory = ActivitiesApiFactory;
/**
 * ActivitiesApi - object-oriented interface
 */
class ActivitiesApi extends base_1.BaseAPI {
    /**
     * URL `/v1/activities/recipients/{recipient_id}/copy`
     * Copies activities to a new recipient.
     * @summary Copy activities to a new recipient
     * @param {number} recipientId ID of the recipient self circle
     * @param {ActivitiesCopyRecipientRequest} [activitiesCopyRecipientRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesCopyActivitiesV1(params, options) {
        return (0, exports.ActivitiesApiFp)(this.configuration)
            .activitiesCopyActivitiesV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/activities/recipients/{recipient_id}/activities`
     * Builds or returns the daily activities list for the recipient. The decision whether to build a new list or return the existing is based on the required `tz` query parameter - if daily activities have not yet been generated for the user\'s current day (determined by timezone), then a new daily activities list is generated and returned. Otherwise, the list which has already been generated is returned.  Pinned activities are also included in the list and will appear at the front of the list, indicated by `pinnedAt` being non-null.
     * @summary Build or retrieve daily activities list
     * @param {number} recipientId ID of the recipient self circle
     * @param {string} tz IANA timezone identifier (e.g., America/Los_Angeles, Europe/London)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesGetActivitiesListV1(params, options) {
        return (0, exports.ActivitiesApiFp)(this.configuration)
            .activitiesGetActivitiesListV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/activities/recipients/{recipient_id}/activities/{activity_id}`
     * Returns the details for a single user activity based on its ID.
     * @summary get activity details
     * @param {number} recipientId ID of the recipient self circle
     * @param {number} activityId ID of the user activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesGetActivityDetailsV1(params, options) {
        return (0, exports.ActivitiesApiFp)(this.configuration)
            .activitiesGetActivityDetailsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/activities/recipients/{recipient_id}/activities/{activity_id}`
     * Update an existing activity for a specific recipient.  This endpoint allows callers to update the pinned or completion status of an activity by ID for a given recipient.   Limitations:  - Only `self_attest` activities can be marked as completed through this route. - Only one operation of either `pinned` or `completed` can be performed per request.
     * @summary Update an activity
     * @param {number} recipientId ID of the recipient self circle
     * @param {number} activityId ID of the user activity
     * @param {ActivitiesPatchActivityRequest} [activitiesPatchActivityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesPatchActivityV1(params, options) {
        return (0, exports.ActivitiesApiFp)(this.configuration)
            .activitiesPatchActivityV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/activities/pubsub`
     * Generic endpoint for handling Google Cloud Pub/Sub push subscription messages. Currently supports CheckinCreatedEvent for activity regeneration based on checkin completion.  This endpoint receives push messages from Google Cloud Pub/Sub and processes them asynchronously. The endpoint validates the Pub/Sub message format and routes events to appropriate handlers based on event type.
     * @summary Pub/Sub message receiving endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesPubsubV1(params, options) {
        return (0, exports.ActivitiesApiFp)(this.configuration)
            .activitiesPubsubV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/activities/recipients/{recipient_id}/activities/{activity_id}/replace`
     * Replaces an activity with a relevant replacement.
     * @summary replace activity
     * @param {number} recipientId ID of the recipient self circle
     * @param {number} activityId ID of the user activity
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitiesReplaceUserActivityV1(params, options) {
        return (0, exports.ActivitiesApiFp)(this.configuration)
            .activitiesReplaceUserActivityV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.ActivitiesApi = ActivitiesApi;
//# sourceMappingURL=activities-api.js.map